<template>
    <div class="table">
        <div class="container" style="float:right;width:95%;">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker style="width: 150px;"
                    v-model="form.startDate"
                    type="date"
                    placeholder="开始日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker style="width: 150px;"
                    v-model="form.endDate"
                    type="date"
                    placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            </div>
            <div style="display: block; height:40px;float:right;">
                <el-button type="primary" class="handle-del mr10" @click="setCustom">自定义报告输出</el-button>
                <el-button type="danger" class="handle-del mr10" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
            </div>
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="550"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)"
                border
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="name" label="报告名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="startDate" label="开始日期" width="120">
                    <template slot-scope="scope">
                        {{ scope.row.startDate ? scope.row.startDate.substring(0, 10) : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="endDate" label="结束日期" width="120">
                    <template slot-scope="scope">
                        {{ scope.row.endDate ? scope.row.endDate.substring(0, 10) : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="releaseTime" label="发布时间" width="150"></el-table-column>
                <el-table-column prop="" label="发布状态" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 0">
                            <span style="color:red;">待发布</span>
                        </div>
                        <div v-else-if="scope.row.status == 1">
                            已发布
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="110px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="downloadReport(scope.row)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            查看报告
                        </el-button>
                        <el-button v-if="scope.row.status == 0"
                            @click.native.prevent="setStatus(scope.row, 1)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            发布
                        </el-button>
                        <el-button v-if="scope.row.status == 1"
                            @click.native.prevent="setStatus(scope.row, 0)"
                            type="text"
                            size="small" style="color: red;">
                            撤回
                        </el-button>
                        <el-button style="color: red"
                            @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!--自定义日期输出 -->
        <div v-if="customReportVisible">
            <customReport ref="customReport"></customReport>
        </div>
    </div>
</template>

<script>
    import http from '../../../../../common/http';
    import customReport from './customReport.vue';

    export default {
        name:"ClassWeekReport",
        data(){
            return{
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    startDate:"",
                    endDate:"",
                },
                customReportVisible: false,
                depts:[],
                data:[],
                loading:false,
                loadingText:"",
            }
        },
        components: {
            customReport
        },
        created:function () {
            this.getDeptData()
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            getDeptData(){
                let url = this.listDeptUrl
                let data = {parentId:"0"}
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list
                        if(this.depts.length>0){
                            this.form.deptId=this.depts[0].id
                        }
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true
                this.loadingText="数据加载中..."

                let url = this.classWeekReportListUrl
                let data = {
                    isPage: this.common.isPage,
                    page: this.common.page,
                    limit: this.common.pageSize,
                    deptId: this.form.deptId,
                    startDate:this.$util.isEmpty(this.form.startDate)?"":this.form.startDate,
                    endDate:this.$util.isEmpty(this.form.endDate)?"":this.form.endDate,
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list
                        this.common.total = res.data.total
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    this.loading=false
                });
            },
            //删除
            del(data){
                this.form.id = data.id
                this.$commonFn.showConfirm(this.delSuccess)
            },
            delSuccess(){
                this.loading=true
                this.loadingText="正在删除中..."

                let url = this.classWeekReportDelUrl
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    this.loading=false
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1)
                        this.common.page = 1
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                    this.loading=false
                })
            },
            //批量删除
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array()
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i])
                        }
                    }
                    let idStr =checkIdArr.join(",")
                    this.form.id= idStr
                    this.$commonFn.showConfirm(this.delSuccess)
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2)
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = []
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id)
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            // 发布与撤回
            setStatus(data,status){
                this.loading=true
                let url = ""
                if(status == 0){
                    this.loadingText="撤回报告中..."
                    url = this.classWeekReportCancelUrl
                }else if(status == 1){
                    this.loadingText="发布报告中..."
                    url = this.classWeekReportReleaseUrl
                }
                let reqParam = {
                    id: data.id,
                    status: status
                };
                this.apiPost(url,reqParam).then((res) => {
                    if(res.status==200){
                        this.$commonFn.showTip(res.message,1)
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    this.loading=false
                });
            },
            // 查看报告
            async downloadReport(data){
                const link = document.createElement('a');
                link.href = data.reportUrl;
                link.download = '班级评级周报.pdf';
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            // 自定义日志输出
            setCustom(){
                this.customReportVisible = true;
                this.$nextTick(() => {
                    this.$refs['customReport'].init(this.form.deptId);
                })
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/classWeekReport/list.vue